import React from 'react';
import { Eyebrow } from '../primitives';

/**
 * PHLD.ai — Witness/fixer story. The one place her journey is the content:
 * twenty-five years inside the houses, then the engineering of the AI era.
 */
export function Story() {
  const section: React.CSSProperties = { background: 'var(--surface-ink)', color: 'var(--text-on-ink)' };
  const inner: React.CSSProperties = {
    maxWidth: 'var(--container)',
    margin: '0 auto',
    padding: 'var(--space-10) var(--gutter)',
    display: 'grid',
    gridTemplateColumns: '0.8fr 1.2fr',
    gap: 'var(--space-9)',
    alignItems: 'center',
  };
  const portrait: React.CSSProperties = {
    width: '100%',
    aspectRatio: '4/5',
    objectFit: 'cover',
    borderRadius: 'var(--radius-lg)',
    filter: 'grayscale(0.15)',
    boxShadow: 'var(--shadow-lg)',
  };
  const head: React.CSSProperties = {
    fontWeight: 'var(--weight-extralight)' as any,
    fontSize: 'clamp(1.9rem, 3.6vw, 3rem)',
    lineHeight: 1.16,
    letterSpacing: 'var(--tracking-tight)',
    color: 'var(--blush)',
    margin: 'var(--space-5) 0 0',
    maxWidth: '20ch',
  };
  const body: React.CSSProperties = {
    fontSize: 'var(--text-body-l)',
    color: 'var(--text-on-ink-muted)',
    lineHeight: 'var(--leading-relaxed)',
    margin: 'var(--space-6) 0 0',
    maxWidth: '52ch',
  };
  const evidence: React.CSSProperties = {
    marginTop: 'var(--space-7)',
    paddingTop: 'var(--space-6)',
    borderTop: '1px solid var(--border-on-ink)',
    display: 'flex',
    alignItems: 'baseline',
    gap: 'var(--space-4)',
    flexWrap: 'wrap',
  };
  const evText: React.CSSProperties = { color: 'var(--text-on-ink-muted)', fontSize: 'var(--text-small)', maxWidth: '40ch' };

  return (
    <section style={section} id="the-story">
      <div style={inner} className="phld-story-grid">
        <img src="/assets/brand/founder-portrait.png" alt="Olesya Tarasova" style={portrait} />
        <div>
          <Eyebrow onInk>The story</Eyebrow>
          <h2 style={head}>For twenty-five years, I was on your concept team, and I delivered.</h2>
          <p style={body}>
            For twenty-five years I was on the floor, not watching, building. As a lighting engineer
            and designer for the finest luxury houses, I built the systems that carried each brand&apos;s
            philosophy into its space: the concept, the engineering, the light that made a boutique
            feel like the brand itself. I worked shoulder to shoulder with extraordinary people:
            architects, project managers, installers, merchandisers. And I carried the same load they
            did: paper trails, endless reporting, hours lost to admin and orchestration that had
            nothing to do with the work we were hired for.
          </p>
          <div style={evidence}>
            <span style={evText}>
              So I stepped out: three years building software, SaaS, and AI systems. Now both worlds
              work for you, combined: a deep understanding of your brand and your processes, lived
              through twenty-five years inside the houses, and the engineering of the new AI era.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
